import React, { useContext, useState } from 'react';
import Image from 'react-bootstrap/Image';
import Logo from '../../../margretlogo.png';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import { GlobalContext } from '../../context/provider';
import moment from "moment";
import '../css/onprinttoggle.css';
import numberbeautifuly from '../../../utils/numberbeautify';

const Printexpense = props => {
    const { dailyexpenseState } = useContext(GlobalContext);
    return (
        <div className='print_show'>
            <Container>
                <Row className='justify-content-md-center mt-3'>
                    <Image src={Logo} style={{ width: 110, height: 100 }} />
                    <center><span>لیستی خەرجی ڕۆژانەی پەیمانگە لە بەرواری {moment(props.from).format('YYYY-MM-DD')} بۆ بەرواری {moment(props.to).format('YYYY-MM-DD')}</span></center>
                </Row>
                <Row className='justify-content-md-center mt-3'>
                    <table>
                        <thead style={{ border: '2px solid', textAlign: 'center' }}>
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <th>ژمارە</th>
                                <th>بڕ</th>
                                <th>شوێن</th>
                                <th colSpan="2">بەروار</th>
                                <th>جۆری خەرجی</th>
                                <th>تێبینی</th>
                            </tr>
                        </thead>
                        <tbody style={{ border: '2px solid', textAlign: 'center', fontSize: 12 }}>
                            {dailyexpenseState.daily_expense.map((lis, index) => (
                                <tr style={{ border: '2px solid' }}>
                                    <td>{index + 1}</td>
                                    <td>{numberbeautifuly(lis.daily_expense_amount)} IQD</td>
                                    <td>{lis.daily_expense_location}</td>
                                    <td colSpan="2">{moment(lis.daily_expense_date).format('YYYY-MM-DD')}</td>
                                    <td>{lis.daily_expense_type}</td>
                                    <td>{lis.daily_expense_note}</td>
                                </tr>
                            ))}
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <td colSpan={5} style={{ border: '2px solid', textAlign: 'center' }}>کۆی خەرجی</td>
                                <td>{dailyexpenseState.daily_expense.reduce((a, v) => a = Number(a) + Number(v.daily_expense_amount), 0)} IQD</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
                <div style={{ width: '100%', marginTop: '5vh', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '50%' }}>
                        <span>سارا سعدی عمر<br />
                            ژمێریار</span>
                    </div>
                    <div style={{ width: '50%', display: 'flex', justifyContent: "flex-end" }}>
                        <span>ئاڤان ئەحمەد حەمە<br />
                            بەڕێوەبەر</span>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Printexpense